module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Black.64be56a.eot";